
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Settings } from "lucide-react";
import { InstalacaoFormData } from "../tabs/InstalacaoTab";

export const InstallationControlSection = () => {
  const { control } = useFormContext<InstalacaoFormData>();

  return (
    <div className="space-y-4 p-4 bg-blue-50 rounded-lg">
      <h3 className="text-lg font-medium text-blue-800 flex items-center gap-2">
        <Settings className="h-5 w-5" /> 
        Controle de Etapas Obrigatórias
      </h3>
      
      <p className="text-sm text-gray-600 mb-4">
        Configure quais etapas são obrigatórias no formulário da calculadora solar. 
        Isso determinará o fluxo e validações durante o cálculo.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-4">
          <h4 className="font-medium text-sm text-blue-700">Informações Básicas</h4>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.selecionarConcessionaria"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-concessionaria"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-concessionaria" className="text-sm font-medium">
                Selecionar Concessionária
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa selecionar uma concessionária
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.informarTipoTensao"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-tipo-tensao"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-tipo-tensao" className="text-sm font-medium">
                Informar Tipo de Tensão
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa selecionar o tipo de tensão
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.selecionarTipologia"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-tipologia"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-tipologia" className="text-sm font-medium">
                Selecionar Tipologia
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa selecionar uma tipologia
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.selecionarTipoTarifa"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-tipo-tarifa"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-tipo-tarifa" className="text-sm font-medium">
                Selecionar Tipo de Tarifa
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa selecionar um tipo de tarifa
              </p>
            </div>
          </div>
        </div>
        
        <div className="space-y-4">
          <h4 className="font-medium text-sm text-blue-700">Dados Técnicos</h4>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.informarDifusaoAzimutal"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-difusao-azimutal"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-difusao-azimutal" className="text-sm font-medium">
                Informar Difusão Azimutal
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa configurar a difusão azimutal
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.informarInclinacaoTelhado"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-inclinacao-telhado"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-inclinacao-telhado" className="text-sm font-medium">
                Informar Inclinação do Telhado
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa configurar a inclinação do telhado
              </p>
            </div>
          </div>
          
          <div className="flex items-start space-x-2">
            <Controller
              name="etapasObrigatorias.selecionarTipoTelhado"
              control={control}
              render={({ field }) => (
                <Checkbox
                  id="check-tipo-telhado"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              )}
            />
            <div className="grid gap-1.5 leading-none">
              <Label htmlFor="check-tipo-telhado" className="text-sm font-medium">
                Selecionar Tipo de Telhado
              </Label>
              <p className="text-xs text-muted-foreground">
                O usuário precisa selecionar um tipo de telhado
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
